import type { ToolActivity } from "../tool-activity";
import { toolActivityHostname } from "../tool-activity-hostname";
import type { ToolActivityState } from "../tool-activity-state";
import { toolInput } from "../tool-input";
import { stateLabel } from "../state-label";
import { BROWSER_HISTORY_LABELS } from "./browser-activity-constants";

export function describeBrowserNavigate(
  record: Record<string, unknown>,
  state: ToolActivityState,
): ToolActivity {
  const action = toolInput.str(record.action);
  if (action && action !== "goto") {
    const move = Object.hasOwn(BROWSER_HISTORY_LABELS, action)
      ? BROWSER_HISTORY_LABELS[action]
      : undefined;
    return move
      ? stateLabel(state, {
          failed: `Could not ${move.bare}`,
          running: move.gerund,
          done: move.done,
        })
      : stateLabel(state, {
          failed: "Could not move in the browser",
          running: "Moving in the browser",
          done: "Moved in the browser",
        });
  }
  const host = toolActivityHostname(toolInput.str(record.url));
  const subject = host ?? "a page";
  return stateLabel(state, {
    failed: `Could not open ${subject}`,
    running: `Opening ${subject}`,
    done: `Opened ${subject}`,
  });
}
